import { useState } from "react";
import styled, { keyframes } from "styled-components";
const fadeIn = keyframes`
  from {
    opacity: 0.5;
  }
  to {
    opacity: 1;
  }
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  max-width: 450px;
  @media (max-width: 800px) {
    max-width: 340px;
  }
`;

const MainImageContainer = styled.div`
  position: relative;
  width: 100%;
  height: fit-content;
  overflow: hidden;
`;

const MainImage = styled.img`
  width: 450px;
  height: 600px;
  object-fit: cover;
  animation: ${fadeIn} 0.3s ease;
  transition: opacity 0.3s ease;
  @media (max-width: 800px) {
    width: 340px;
    height: 520px;
  }
`;

const NavigationButton = styled.button`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(255, 255, 255, 0.8);
  border: none;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: rgba(255, 255, 255, 1);
  }

  svg {
    width: 24px;
    height: 24px;
  }
`;

const LeftButton = styled(NavigationButton)`
  left: 0px;
`;

const RightButton = styled(NavigationButton)`
  right: 0px;
`;

const ThumbnailContainer = styled.div`
  display: flex;
  gap: 5px;
`;

const Thumbnail = styled.div`
  width: 65px;
  height: 100px;
  overflow: hidden;
  cursor: pointer;
  border: 2px solid ${(props) => (props.isActive ? "#000" : "transparent")};
  transition: all 0.2s ease;

  &:hover {
    /* transform: scale(1.05); */
    border-color: #666;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  @media (max-width: 800px) {
    width: 49px;
    height: 85px;
  }
`;

function ProductImageViewer({ images }) {
  const [currentIndex, setCurrentIndex] = useState(0);

  const goToNext = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === images.length - 1 ? 0 : prevIndex + 1
    );
  };

  const goToPrevious = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };

  const selectImage = (index) => {
    setCurrentIndex(index);
  };

  return (
    <Wrapper>
      <MainImageContainer>
        <MainImage
          src={process.env.REACT_APP_IMAGE_BASE_URL + images[currentIndex].path}
          alt={`Product view ${currentIndex + 1}`}
        />

        <LeftButton onClick={goToPrevious} aria-label="Previous image">
          <svg
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M15 18L9 12L15 6"
              stroke="#000000"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </LeftButton>

        <RightButton onClick={goToNext} aria-label="Next image">
          <svg
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9 18L15 12L9 6"
              stroke="#000000"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </RightButton>
      </MainImageContainer>

      <ThumbnailContainer>
        {images.map((image, index) => (
          <Thumbnail
            key={index}
            isActive={index === currentIndex}
            onClick={() => selectImage(index)}
          >
            <img
              src={process.env.REACT_APP_IMAGE_BASE_URL + image.path}
              alt={`Thumbnail ${index + 1}`}
            />
          </Thumbnail>
        ))}
      </ThumbnailContainer>
    </Wrapper>
  );
}

export default ProductImageViewer;
